import { vesselUpdatesConstants } from '../../_constants';

export function vesselUpdates(state = {}, action) {
    switch (action.type) {
        case vesselUpdatesConstants.VESSEL_UPDATES_FETCHING:
            return {
                ...state,
                vesselUpdatesFetching: true
            };
        case vesselUpdatesConstants.VESSEL_UPDATES_FETCHED:
            return {
                ...state,
                vesselUpdatesFetching: false
            };
        case vesselUpdatesConstants.VESSEL_UPDATES_SUBMITTING:
            return {
                ...state,
                vesselUpdatesSubmitting: true
            };
        case vesselUpdatesConstants.VESSEL_UPDATES_SUBMITTED:
            return {
                ...state,
                vesselUpdatesSubmitting: false
            };
        case vesselUpdatesConstants.GET_VESSEL_HEADER_DETAILS_BY_VUID:
            return {
                ...state,
                vesselHeaderDetails: action.vesselHeaderDetails
            };
        case vesselUpdatesConstants.VESSEL_UPDATES:
            return {
                ...state,
                vesselUpdates: action.vesselUpdates
            };
        case vesselUpdatesConstants.CREATE_VESSEL_DETAILS:
            let _vesselHeaderDetails = [Object.assign({}, ...state.vesselHeaderDetails)];
            _vesselHeaderDetails[0].vesselsToUpdate[action.index] = action.newVesselDetails;
            return {
                ...state,
                vesselHeaderDetails: _vesselHeaderDetails
            };
        default:
            return state;
    }
}